export default "__VITE_ASSET__D0Z_cX$w__"